import api from './index'

const resource = 'art_kinds'

export default {
  getArtKinds () {
    return api.get(resource)
  }
}
